/**
 * Facet Expand All (Desktop only)
 * ================================
 * Oeffnet alle Filter-Akkordeons auf Desktop automatisch,
 * ohne die Theme-Einstellung "expand_filter_groups" zu nutzen.
 *
 * Funktioniert auch nach AJAX-Filter-Updates (FacetForm re-render).
 *
 * Einbindung:
 * - Als Asset hochladen (facet-expand-all.js)
 * - In snippets/facets.liquid ODER theme.liquid vor </body> einbinden:
 *   <script src="{{ 'facet-expand-all.js' | asset_url }}" defer></script>
 *
 * Alternativ: Direkt als <script> in theme.liquid vor </body> einbetten.
 */
(function () {
  'use strict';

  var DESKTOP_MIN = 768;

  function expandAllFilters() {
    if (window.innerWidth < DESKTOP_MIN) return;

    var filters = document.querySelectorAll('details.facet-accordion-details');
    for (var i = 0; i < filters.length; i++) {
      if (!filters[i].hasAttribute('open')) {
        filters[i].setAttribute('open', '');
      }
    }
  }

  // 1. Initial: nach DOM-ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', expandAllFilters);
  } else {
    expandAllFilters();
  }

  // 2. Nach AJAX-Filter-Updates: MutationObserver auf die Facet-Container
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      if (mutations[i].addedNodes.length > 0) {
        expandAllFilters();
        break;
      }
    }
  });

  function observeFacets() {
    var forms = document.querySelectorAll('form[is="facet-form"]');
    forms.forEach(function (form) {
      observer.observe(form, { childList: true, subtree: true });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observeFacets);
  } else {
    observeFacets();
  }
})();
